<template>
  <div class="field-menu-item d-flex justify-content-between align-center py-1">
    <div>
      {{ field.title }}
      <span
        class="text-secondary text-small"
        v-if="field.projectId && field.fieldType === InitiativeFieldType.CUSTOM_FIELD"
        >({{ projectTitle }})</span
      >
    </div>
    <div class="d-flex align-items-center field-actions">
      <i
        :id="uuid + '-edit'"
        class="pencil-simple-icon field-action-icon"
        @click="$emit('edit')"
        v-if="field.fieldType === InitiativeFieldType.CUSTOM_FIELD"
      ></i>
      <i
        :id="uuid + '-remove'"
        class="close-icon field-action-icon"
        @click="$emit('remove')"
        v-if="showRemoveIcon"
      ></i>
      <b-form-checkbox
        :checked="field.isDisplayedField"
        :disabled="field.isDisabled"
        @change="$emit('select', $event)"
        name="check-button"
        switch
      />
    </div>
    <tooltip :target="uuid + '-edit'" v-if="field.fieldType === InitiativeFieldType.CUSTOM_FIELD"
      >Edit Custom Field
    </tooltip>
    <tooltip :target="uuid + '-remove'" v-if="showRemoveIcon">Remove Custom Field</tooltip>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue'
import { InitiativeFieldType } from '@/constants/initiative'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import { BFormCheckbox } from 'bootstrap-vue'
import { mapActions } from 'vuex'

/**
 * This component the Item component for Initiative Field(Custom as well as System). It is used in InitiativeFieldsMenu.
 */
export default {
  name: 'InitiativeFieldsMenuItem',
  props: ['field', 'projectId', 'teamId', 'orgId', 'showRemoveIcon'],
  mixins: [ComponentIdMixin],
  components: { Tooltip, BFormCheckbox },
  data() {
    return {
      InitiativeFieldType
    }
  },
  computed: {
    projectTitle() {
      if (this.field.projectId && !this.projectId) {
        // If the Project CF is shown outside the scope of project, show project title
        return this.$store.getters['project/projectById'](this.field.projectId)?.title
      }
      return 'project'
    }
  },
  methods: {
    ...mapActions('project', ['getProject'])
  },
  mounted() {
    if (this.field.projectId && !this.projectId) {
      // If the Project CF is shown outside the scope of project, show project title
      this.getProject({ projectId: this.field.projectId, orgId: this.orgId })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.field-actions {
  gap: 8px;
}

.field-action-icon {
  border: 1px solid $borderPrimary;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    border-color: $borderTertiary;
  }
}

.pencil-simple-icon {
  height: 18px;
}

.close-icon {
  padding: 8px;
}

.field-action-icon {
  visibility: hidden;
}

.field-menu-item:hover .field-action-icon {
  visibility: visible;
}
</style>
